import {
    API_GET_ACCOUNT_STATEMENT_TO_DOWNLOAD_PENDING,
    API_GET_ACCOUNT_STATEMENT_TO_DOWNLOAD_SUCCESS
} from '../../api/lendingAPI/LendingAPI.actions';
import { mergeStates } from '../../iwProvider/StoreHelper';
import * as actions from './AccountHistory.actions';

const initialState = {
    ready: false,
    downloading: false
};

// eslint-disable-next-line import/no-default-export
export default function (
    state = mergeStates(initialState),
    action: { type: string }
) {
    switch (action.type) {
        case actions.ACCOUNT_HISTORY_DATA_LOADING:
            return mergeStates(state, {
                ready: false
            });

        case actions.ACCOUNT_HISTORY_READY:
            return mergeStates(state, {
                ready: true
            });

        case API_GET_ACCOUNT_STATEMENT_TO_DOWNLOAD_PENDING:
            return mergeStates(state, {
                downloading: true
            });

        case API_GET_ACCOUNT_STATEMENT_TO_DOWNLOAD_SUCCESS:
            return mergeStates(state, {
                downloading: false
            });

        case actions.LEAVE_ACCOUNT_HISTORY:
            return mergeStates(initialState);

        default:
            return state;
    }
}
